// extracted by mini-css-extract-plugin
export default {"productGrid":"dZ-z","centerLink":"eZ-z","productSection":"fZ-z","item":"gZ-z","ctaButton":"hZ-z"};